import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { MoveContentDocument } from './move.generated';

export const useMoveContent = (options: ApiOptions<typeof MoveContentDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(MoveContentDocument, {
    ...useNotifications(MoveContentDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.content.move_success'),
    }),
    ...options,
  });
};
